import { ConfirmConsultationResponse } from '../../../../../types/models/consultations/consultation.types';
import { api } from '../../../../../utils/api/api';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[confirmConsultationQuery]';

export const CONFIRM_CONSULTATION_QUERY_KEY = 'CONFIRM_CONSULTATION';

export const queryConfirmConsultation = async (consultationId: number) => {
  console.log(PREFIX, `Confirming consultations...`);
  const response = await CONSULTATIONS_ENDPOINTS.confirm(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Confirmed consultation.`);
  return json as ConfirmConsultationResponse;
};

export const downloadAttachment = async (filename: string) => {
  const response = await api.get(
    `consultations/download/attachment`,
    {
      filename
    },
    {
      responseType: 'blob',
      method: 'GET',
    }
  );

  const { ok, data } = response;

  if (!ok) {
    const error = response.data;
    console.log('An error occurred.', error);
    throw error;
  }

  // @ts-ignore
  const href = URL.createObjectURL(data);

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', '');
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};
